module.exports = __webpack_public_path__ + "static/media/18ECA12.58e3fbd2.jpg";